import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import SideBarPolls from "../components/SideBarPolls";
import NewsPoll from "./NewsPoll"; // Importing the new NewsPoll component
import RelatedNews from "./RelatedNews"; 
import { getUserIdFromToken } from "../services/authService"; // ✅ Import function
import {getCommentsByNewsId} from "../services/newsService";


const NewsDetailComp = ({ news, onSubmit, loading}) => {
  const [formData, setFormData] = useState({
    newsId: "",
    CommentText : "",
    userId : "",
  });
  const navigate = useNavigate();
  const [totalLikes, setTotalLikes] = useState(0);
  const [comments, setComments] = useState([]);
  const userId = getUserIdFromToken(); // ✅ Dummy User ID (Replace with real user ID)


  useEffect(() => {
  if (news && news.likes) {
    setTotalLikes(news.likes.length);
  }
  if (news && news.id) {
    fetchComments(news.id); // ✅ use helper to fetch and set comments

    setFormData((prev) => ({
      ...prev,
      newsId: news.id,
      userId: userId || 0,
    }));
  }
}, [news, userId]);


   const fetchComments = async (newsId) => {
  const res = await getCommentsByNewsId(newsId);
  if (res && Array.isArray(res)) {
    setComments(res);
  } else {
    setComments([]);
  }
};

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  await onSubmit(formData);

  // Clear comment text
  setFormData((prev) => ({ ...prev, CommentText: "" }));

  // Refresh comments
  fetchComments(formData.newsId);
};

  if (!news) return <p>No news found.</p>;

  return (
    <div className="single-post">
      <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-8">
            <div className="sn-container">
              <div className="sn-img">
                <img src={news.imagePath} alt={news.imageAltText} />
              </div>
              <div className="sn-content">
                <p className="text-muted small mt-4">
                  By <span className="fw-semibold">{news.createdBy}</span> |{" "}
                  {new Date(news.createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}{" "}
                  {new Date(news.createdAt).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </p>

                <div className="text-center my-4">
                  <h1 className="fw-bold text-dark post-title">{news.title}</h1>
                  <h5 className="fw-medium text-muted mt-3 post-subtitle">
                    {news.subTitle}
                  </h5>
                </div>

                <p
                  className="post-description"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(news.description),
                  }}
                ></p>

<div className="form-group col-md-6">
  <textarea
    className="form-control"
    name="CommentText"
    placeholder="Please add your Comments"
    required
    rows={4} // You can adjust this value to make it taller
    value={formData.CommentText}
    onChange={handleChange}
  ></textarea>
</div>
                  <div>
                  <button className="btn" type="submit" disabled={loading}>
                    {loading ? "Adding..." : "Add Comments"}
                  </button>
                  </div>
                  
                  <div className="mt-5">
            <h4 className="fw-bold">Comments:</h4>
            {comments.length === 0 ? (
              <p>No comments yet.</p>
            ) : (
              <ul className="list-group">
                {comments.map((comment, index) => (
                  <li key={index} className="list-group-item">
                    <strong>{comment.username || "Anonymous"}:</strong> {comment.commentText}
                  </li>
                ))}
              </ul>
            )}
          </div>             

                {/* ✅ Show poll only if news.pollDto exists */}
                {news.pollDto && <NewsPoll poll={news.pollDto} />}
              </div>
            </div>
            {/* ✅ Add Related News Component */}
            <RelatedNews categorySlug={news.category} newsSlug={news.slug} />
          </div>
         

          {/* Sidebar Section */}
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="sidebar">
              <SideBarPolls />
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  );
};

export default NewsDetailComp;
